import { BaseService } from "./common/base";

export class PatientCheckupService extends BaseService<any> {
  constructor() {
    super("patient-checkup");
  }

  public findByNir(nir: string): Promise<any[]> {
    return this._get(`/nir/${nir}`);
  }
}
